<div class="nav-bar-container">
  <div class="nav-bar-logo-container">
    <img [src]="'/assets/shared-lib/logos/pga-logo-white.svg'" alt="logo" />
  </div>
  <ng-content></ng-content>
</div>
